import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import Lozenge from '@atlaskit/lozenge';

import { fg } from '@confluence/feature-gating';

const i18n = defineMessages({
	beta: {
		id: 'live-pages-features.beta.lozenge',
		defaultMessage: 'Beta',
		description:
			'Text for the beta lozenge. Informs users that the associated feature is in a beta phase.',
	},
	new: {
		id: 'live-pages-features.new.lozenge',
		defaultMessage: 'New',
		description: 'Text for the new lozenge. Informs users that the associated feature is new.',
	},
});

type LivePagesBetaLozengeProps = {
	bold?: boolean;
};

export const LivePagesBetaLozenge = ({ bold = false }: LivePagesBetaLozengeProps) => (
	<Lozenge appearance="new" isBold={bold}>
		<FormattedMessage {...(fg('live_pages_ga_ui') ? i18n.new : i18n.beta)} />
	</Lozenge>
);
